import { render, staticRenderFns } from "./ChannelUserProfileItem.vue?vue&type=template&id=36639dd2&scoped=true&"
import script from "./ChannelUserProfileItem.vue?vue&type=script&lang=ts&"
export * from "./ChannelUserProfileItem.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelUserProfileItem.vue?vue&type=style&index=0&id=36639dd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36639dd2",
  null
  
)

export default component.exports